import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'copy-tactic-modal',
    templateUrl: './copy-tactic.modal.html',
    styleUrls: ['./copy-tactic.modal.scss'],
})
export class CopyTacticModal implements OnInit {
    
    isCopyPositions: boolean = true;
    isCopySettings: boolean = true;
    isCopyPlayerSettings: boolean = true;
    destination: number;

    tactics: number[];

    @Input() currentTactic: number;
   
    constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.tactics = [];
        for (let i = 0; i < 7; i++) {
            this.tactics.push(i+1);
        }
    }

    changeCopyPositions(val: boolean) {
        this.isCopyPositions = val;  
    }

    changeCopySettings(val: boolean) {
        this.isCopySettings = val;  
    }

    changeCopyPlayerSettings(val: boolean) {
        this.isCopyPlayerSettings = val;  
    }

    changeDestination(item: number) {
        this.destination = item;  
    }

    onSubmit() {
        if (this.destination) {
            let result = {
                isCopyPositions: this.isCopyPositions,
                isCopySettings: this.isCopySettings,
                isCopyPlayerSettings: this.isCopyPlayerSettings,
                destination: this.destination
            };

            this.activeModal.close(result);
        }
    }

    isCopyPositionsSelected(): boolean {
        return this.isCopyPositions;
    }

    isCopySettingsSelected(): boolean {
        return this.isCopySettings;
    }

    isCopyPlayerSettingsSelected(): boolean {
        return this.isCopyPlayerSettings;
    }

    isTacticSelected(item: number): boolean {
        return this.destination === item;
    }

    isTacticDisabled(item: number) : boolean {
        return item === this.currentTactic;
    }
}